import { api } from "@/api/utils";
import { DataTable } from "@/components/data-table/DataTable";
import { DataTableBody } from "@/components/data-table/DataTableBody";
import { DataTableFooter } from "@/components/data-table/DataTableFooter";
import { PointsAmount } from "@/components/PointsAmount";
import { PageWrapper } from "@/components/ui/PageWrapper";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { number, object, optional } from "valibot";

export const Route = createFileRoute("/admin/reports/$countryCode/card-payments")({
  component: PaymentsPage,
  validateSearch: object({
    "page-size": optional(number()),
    page: optional(number()),
  }),
});

function getCardPaymentsQuery(page: number, pageSize: number) {
  return queryOptions({
    queryKey: ["card-payments", page, pageSize],
    queryFn: async () => {
      return await api.reporting.getManagementReportingObsPayments({ page, pageSize });
    },
  });
}

function PaymentsPage() {
  const search = Route.useSearch();
  const { "page-size": pageSize, page } = search;
  const completedPayments = useQuery(getCardPaymentsQuery(page ?? 1, pageSize ?? 100));

  return (
    <PageWrapper title="Card Payments">
      <DataTable>
        <DataTableBody
          data={completedPayments.data?.completed_payments ?? []}
          dataKey={"payment_id" as any}
          rounded="top"
          columns={[
            {
              cell: "purchase_date",
              header: "Purchase Date",
              formatter: "date",
            },
            {
              cell: "purchase_date",
              header: "Time",
              formatter: "time",
            },
            {
              cell: p => (p.payment_type === "topup" ? "Top Up" : "Gift"),
              header: "Payment Type",
            },
            {
              cell: "member_name",
              header: "Member Name",
            },
            {
              cell: c => <PointsAmount amount={c.number_of_tokens_purchased} tokenCurrency={c.token_currency} />,
              header: "Number of Points",
              formatter: "number",
            },
            {
              cell: p => (p.purchase_price / 100).toFixed(2),
              header: "Purchase Price",
              formatter: "currency",
            },
            {
              cell: p => p.purchase_currency.toUpperCase(),
              header: "Currency",
            },
          ]}
        ></DataTableBody>
        <DataTableFooter itemCount={completedPayments.data?.total_count} />
      </DataTable>
    </PageWrapper>
  );
}
